<template>
	<div>
		<el-row :gutter="24" style="min-width:500px">
			<h3 style="padding-left: 10px;">裂变活动列表</h3>
			<div style="padding-left: 10px; float: right;">
				<el-button type="primary" style="margin:10px" @click="add()">添加活动</el-button>
			</div>
			<el-table :data="tableData" :header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }"
				:cell-style="{'text-align': 'center'}">
				<el-table-column prop="name" label="名称" align="center"></el-table-column>
				<el-table-column prop="limitNum" label="参与人数限制" align="center">
					<template slot-scope="scope">
						{{scope.row.limitNum}}
					</template>
				</el-table-column>
				<el-table-column prop="inviterCouponId" label="邀请人券/券包Id" align="center">
					<template slot-scope="scope">
						<el-tag>
							{{scope.row.inviterCoupon == 0?"券":"券包"}}:{{scope.row.inviterCouponId}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="shareCouponId" label="被分享者券/券包ID" align="center">
					<template slot-scope="scope">
						<el-tag>
							{{scope.row.shareCouponId == 0?"券":"券包"}}:{{scope.row.shareCouponId}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="hidden" label="状态">
					<template slot-scope="scope">
						{{scope.row.hidden?'下架':'上架'}}
					</template>
				</el-table-column>
				<el-table-column prop="img" label="详情页">
					<template slot-scope="scope">
						<el-image :src="scope.row.img" style="width: 150px;height: 150px;"></el-image>
					</template>
				</el-table-column>
				<el-table-column width="180" label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="deit(scope.row.id)" style="margin-right: 30px;">编辑</el-button>
						<el-button type="text" @click="hiddenordel(scope.row.id)">
							<span style="color: red;">删除</span>
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-row>
		<div style="text-align: center;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="query.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
				layout="total,sizes, prev, pager, next, jumper" :total="query.total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import upload from "../../compents/upload/upload";
	export default {
		components: {
			upload
		},
		data() {
			return {
				tableData: [],
				query: {
					page: 0,
					size: 10,
				},
				total: ''
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			getList() {
				this.$http.get("dMarketingShare/list" + "?pageNum=" + this.query.page + "&pageSize=" + this.query.size)
					.then(res => {
						this.tableData = res.body.data
						this.total = res.body.total
					})
			},
			add() {
				this.$router.push("/DmarketingShare")
			},
			deit(id) {
				this.$router.push({
					path: '/DmarketingShare',
					query: {
						id: id
					}
				})
			},
			hiddenordel(id) {
				this.$confirm('此操作将永久删除该活动, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get("dMarketingShare/delete" + "?id=" + id).then(res => {
						if (res.body.code == 200) {
							this.$message.success("删除成功")
							this.getList()
						}
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			handleSizeChange(val) {
				this.query.size = val;
				this.getList();
			},
			handleCurrentChange(val) {
				this.query.page = val
				this.getList();
			},
		}
	}
</script>

<style>
</style>